module.exports = __webpack_public_path__ + "img/Woveon5.571a8d7c.jpg";